module.exports = __webpack_public_path__ + "img/icon-search.e6bc61f5.svg";